<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.id > 0 ? '编辑' : '新建'"
      width="620px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        label-width="auto">
      <el-form-item prop="fileType" label="产线工序" :rules="$rule.notNull">
        <el-input v-model="model.productLineDesc" placeholder="产线工序" disabled>
          <el-button
              slot="append"
              icon="el-icon-search"
              style="margin-left: 2%;"
              @click="$refs.workLineInfoSelect.open()">
            选择
          </el-button>
        </el-input>
        <work-line-info-select ref="workLineInfoSelect" @select="selectWorkLineInfo"/>
      </el-form-item>
      <el-form-item prop="fileType" label="工序" :rules="$rule.notNull">
        <el-select
            v-model="model.processCodeList"
            placeholder="工序"
            multiple
            value-key="processName">
          <el-option               
              v-for="item in processCode"
              :key="item.code"
              :label="item.processName"
              :value="item.code"/>
        </el-select>
      </el-form-item>
      <el-form-item prop="fileName" label="文件名称" :rules="$rule.notNull">
        <div v-if="model.filePath" style="display: flex; gap: 10px">
          <el-input v-model.trim="model.fileName">
            <template slot="append">
              <span>.{{model.fileSuffix}}</span>
            </template>
          </el-input>
          <el-upload
              :disabled="uploadLoading"
              :action="actionUrl"
              :headers="uploadHeaders"
              :before-upload="beforeUpload"
              :on-progress="handleProgress"
              :on-success="handleSuccess"
              :on-error="handlerError"
              accept=".pdf,.xls,.xlsx"
              :show-file-list="false">
            <el-button :loading="uploadLoading" type="text">文件替换</el-button>
          </el-upload>
        </div>
        <el-upload
            v-else
            :disabled="uploadLoading"
            :action="actionUrl"
            :headers="uploadHeaders"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-error="handlerError"
            accept=".pdf,.xls,.xlsx"
            :show-file-list="false">
          <el-button :loading="uploadLoading" type="primary">上传文件</el-button>
        </el-upload>
      </el-form-item>
<!--      <el-form-item prop="needAudit" label="是否审核" :rules="$rule.notNull">-->
<!--        <el-radio-group v-model="model.needAudit" :disabled="!fileChanged && model.status !== 1">-->
<!--          <el-radio :label="false">否</el-radio>-->
<!--          <el-radio :label="true">是</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-form-item>-->
      <el-form-item prop="note" label="备注">
        <el-input v-model="model.note" type="textarea" autosize placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!fileChanged || !model.id || model.status === 1" :loading="submitLoading" type="primary" @click="handleSave">保存</el-button>
      <el-button v-if="fileChanged || !model.id || model.status === 1" :loading="submitLoading" type="success" @click="handleSaveAndSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import WorkLineInfoSelect from "@/views/information/WorkLineInfo/WorkLineInfoSelect";

  export default {
    name: "EsopEdit",
    components: {WorkLineInfoSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        fileChanged: false,
        changedKey: 1000,
        treeType: [],
        fileTypes: [],
        actionUrl: window.config.basicServerUrl + "esops/upload",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        processCode:[],
        model: {
          id: "",
          fileType: "PCBA",
          version: "",
          originFileName: "",
          fileName: "",
          filePath: "",
          pdfFilePath: "",
          pdfPageSize: "",
          needAudit: "",
          status: "",
          auditStatus: "",
          note: "",
          fileSuffix: "",
          productLine:"",
          productLineDesc:"",
          processCode:"",
          processCodeDesc:"",
          processCodeList:[],
        },
      };
    },
    methods: {
      open(id) {
        this.model.id = id;
        this.fileChanged = false;
        this.dialogVisible = true;
        this.getTypeTree();
        if (id > 0) {
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `esops/detail/${this.model.id}`)
          .then(res => {
            this.model = res;
            this.fileTypes = this.model.fileType ? this.model.fileType.split("/") : [];
            this.processCode=res.workLineInfo.workLineDetails;
            console.log(this.model);
            console.log(this.processCode);
          }).finally(() => {
            this.contentLoading = false;
          });
      },
      getTypeTree() {
        let param = {
          category: 2,
        };
        this.$http.get("basic", "treeTypes", param).then(res => {
          this.treeType = res;
        });
        this.changedKey++;
      },
      fileTypeChanged(value) {
        this.model.fileType = value.join("/");
      },
      beforeUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (![".pdf", ".xls", ".xlsx"].includes(lastName.toLowerCase())) {
          this.$message.error("请上传.pdf,.xls,.xlsx文件类型");
          return false;
        }
        return true;
      },
      handleSuccess(response) {
        if (response) {
          this.model.filePath = response.filePath;
          this.model.fileName = response.fileName;
          this.model.originFileName = response.originFileName;
          this.model.pdfFilePath = response.pdfFilePath;
          this.model.pdfPageSize = response.pdfPageSize;
          this.model.fileSuffix = response.fileSuffix;
          this.fileChanged = true;
        } else {
          this.$message.error("上传失败：" + response.message);
        }
        this.uploadLoading = false;
      },
      handleProgress() {
        this.uploadLoading = true;
      },
      handlerError(err) {
        alert(err);
        this.uploadLoading = false;
      },
      fileDelete(list, index) {
        this.$confirm("确定要删除吗?","提示",{type:"warning"}).then(()=>{
          list.splice(index, 1);
        });
      },
      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "esops", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              }).catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSaveAndSubmit() {
        let url = "esops";
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", url, this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("提交成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      selectWorkLineInfo(row) {
        console.log(row);
        this.processCode=[];
        this.model.productLine=row.code;
        this.model.productLineDesc=row.cname;
        row.workLineDetails.forEach((item) =>this.processCode.push(item));
      },
    },
  };
</script>
<style scoped lang="scss">
.title {
  font-size:16px;
  border-bottom:1px solid #ccc;
  width:100%;
  margin:0 0 5px;
}
</style>
